import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_ESCOPO_GASES } from 'store/modules/api/escopoGases.actions'

const lista = (state = [], { type, payload }) => (
  (type === API_LISTAR_ESCOPO_GASES.success) ? payload.lista : state
)

const total = (state = null, { type, payload }) => (
  (type === API_LISTAR_ESCOPO_GASES.success) ? payload.total : state
)

const isCarregandoLista = loadingReducer(false, API_LISTAR_ESCOPO_GASES)

export default combineReducers({
  lista,
  total,
  isCarregandoLista,
})
